/**
 * O navegador in-app do Instagram/Facebook (WKWebView) tem uma limitação
 * conhecida: depois de navegar pro checkout, ele não repinta a tela nova —
 * fica mostrando a página antiga (às vezes já sem o drawer, se ele foi
 * fechado) até o app ser minimizado e reaberto. Isso acontece na troca de
 * documento em si; não tem trick de JS na nossa página que force esse
 * repaint, porque nesse ponto a página antiga já nem está mais ativa.
 *
 * Solução: tirar o cliente do navegador in-app ANTES de tentar ir pro
 * checkout, já que ali dentro o checkout nunca vai renderizar de forma
 * confiável.
 *
 * - Android: manda automaticamente pro navegador padrão (Chrome) via
 *   intent://, levando o carrinho junto por permalink (não dá pra contar
 *   com cookies compartilhados entre o WebView do Instagram e o Chrome).
 * - iOS: não existe API para forçar a troca de app a partir do WebView do
 *   Instagram — mostramos instruções pro cliente tocar em "•••" e escolher
 *   "Abrir no navegador" (opção nativa do próprio Instagram), com um botão
 *   de apoio para copiar o link do carrinho.
 */
(function () {
  var IN_APP_BROWSER_PATTERNS = [
    /Instagram/i,
    /FBAN|FBAV/i, // Facebook / Messenger in-app browser (mesmo motor, mesmo bug)
  ];

  function isInAppBrowser() {
    var ua = navigator.userAgent || "";
    return IN_APP_BROWSER_PATTERNS.some(function (pattern) {
      return pattern.test(ua);
    });
  }

  if (!isInAppBrowser()) {
    return;
  }

  var isAndroid = /Android/i.test(navigator.userAgent || "");

  function buildCartPermalink(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return null;
    }
    var parts = cart.items.map(function (item) {
      return item.variant_id + ":" + item.quantity;
    });
    return location.origin + "/cart/" + parts.join(",") + "?goto_checkout=1";
  }

  function openInExternalBrowser(url) {
    var stripped = url.replace(/^https?:\/\//, "");
    var intentUrl = "intent://" + stripped + "#Intent;scheme=https;action=android.intent.action.VIEW;end";
    window.location.href = intentUrl;
  }

  function showIOSInstructions(permalinkUrl) {
    var overlay = document.createElement("div");
    overlay.setAttribute("data-inapp-checkout-overlay", "");
    overlay.style.cssText =
      "position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,0.75);" +
      "display:flex;align-items:flex-end;justify-content:center;font-family:-apple-system,sans-serif;";

    var panel = document.createElement("div");
    panel.style.cssText =
      "background:#fff;width:100%;max-width:480px;border-radius:16px 16px 0 0;" +
      "padding:24px 20px calc(24px + env(safe-area-inset-bottom));text-align:center;";

    var title = document.createElement("p");
    title.textContent = "Para finalizar sua compra com segurança, abra o site no navegador.";
    title.style.cssText = "font-size:16px;font-weight:600;margin:0 0 8px;color:#1c1c1c;";

    var subtitle = document.createElement("p");
    subtitle.textContent = "Toque em \u22EF (canto superior) e escolha \"Abrir no navegador\".";
    subtitle.style.cssText = "font-size:14px;margin:0 0 20px;color:#5c5c5c;";

    var copyButton = document.createElement("button");
    copyButton.type = "button";
    copyButton.textContent = "Copiar link do carrinho";
    copyButton.style.cssText =
      "width:100%;padding:14px;border:none;border-radius:12px;background:#1c1c1c;" +
      "color:#fff;font-size:15px;font-weight:600;margin-bottom:10px;cursor:pointer;";
    copyButton.addEventListener("click", function () {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(permalinkUrl).then(function () {
          copyButton.textContent = "Link copiado!";
        });
      }
    });

    var closeButton = document.createElement("button");
    closeButton.type = "button";
    closeButton.textContent = "Fechar";
    closeButton.style.cssText =
      "width:100%;padding:14px;border:none;border-radius:12px;background:transparent;" +
      "color:#5c5c5c;font-size:15px;cursor:pointer;";
    closeButton.addEventListener("click", function () {
      overlay.remove();
    });

    panel.appendChild(title);
    panel.appendChild(subtitle);
    panel.appendChild(copyButton);
    panel.appendChild(closeButton);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);
  }

  document.addEventListener(
    "click",
    function (event) {
      var button = event.target.closest('button[name="checkout"]');
      if (!button) {
        return;
      }
      var form = button.closest("form");
      if (!form) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      fetch("/cart.js", { credentials: "same-origin" })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var permalinkUrl = buildCartPermalink(cart);

          if (!permalinkUrl) {
            // Carrinho vazio ou falha ao ler — deixa seguir pelo fluxo normal.
            form.submit();
            return;
          }

          if (isAndroid) {
            openInExternalBrowser(permalinkUrl);
          } else {
            showIOSInstructions(permalinkUrl);
          }
        })
        .catch(function () {
          // Qualquer falha de rede: não trava o cliente, tenta o fluxo normal.
          form.submit();
        });
    },
    true // capture: intercepta antes de outros listeners de click no botão
  );
})();